import { render, staticRenderFns } from "./ReceptionFresh.vue?vue&type=template&id=3bc9a4fb&scoped=true"
import script from "./ReceptionFresh.vue?vue&type=script&lang=js"
export * from "./ReceptionFresh.vue?vue&type=script&lang=js"
import style0 from "./ReceptionFresh.vue?vue&type=style&index=0&id=3bc9a4fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9a4fb",
  null
  
)

export default component.exports